import { FirebaseError } from "firebase/app";

type TranslateFn = (str: string) => string;

/**
 * Map a Firebase Auth error to a translated, user-facing message.
 *
 * Returns `null` when `error` is not a Firebase auth error, so callers can fall
 * through to their existing API/error handling.
 */
export function getFirebaseAuthErrorMessage(
  error: unknown,
  t: TranslateFn
): string | null {
  if (!(error instanceof FirebaseError)) return null;

  switch (error.code) {
    case "auth/invalid-credential":
    case "auth/invalid-email":
    case "auth/user-not-found":
    case "auth/wrong-password":
      return t("Wrong email or password");
    case "auth/user-disabled":
      return t("This account has been disabled");
    case "auth/too-many-requests":
      return t("Too many attempts. Please try again later");
    case "auth/network-request-failed":
      return t("Network error. Please check your connection");
    default:
      return t("Something went wrong");
  }
}
